import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const basicButtonInput = basic.input({
    id: "basic-input-button",
    label: "Button",
    description: "A simple button, use it to add a call to action to your page.",
    content: withUniqueClass(
        "btn",
        (cls) =>
            `<a class="${cls}" href="#" style="display:inline-block;padding:10px 16px;border-radius:8px;text-decoration:none;">Button</a>`
    ),
});